'use strict'

define ['moment', 'jquery', './accounts.scss'], (moment, $) ->
  ($rootScope, $scope, $http, $q, RentappService, $timeout, $state, $stateParams, Flash, RENTAPPLICATION_API_URL, Account, $cacheFactory) ->
    $scope.next_withdrawal_date = null

    Account.getMe({with_stripe_data:true}).$promise
      .then (response) ->
        if !response.verified
          if response.stripe_recipient_id
            Flash.create('danger', 'ACTION REQUIRED!<br>Our payment processor has updated their compliance terms requiring you to update your Bank details in order to receive payments to your bank account.<br><br>
              Please select "Edit Bank Details" under Account Settings > Bank Account <br>
              You will be asked to re enter your bank details as well as provide additional information on your account.<br>
              You will be required to enter credit card details to submit a payment of $0.00 in order to ensure your changes are saved.<br><br>
              A step-by step guide can be found here: https://tinyurl.com/jwf4wfq', 0)
          else
            $scope.show_verify_notif = true
        else
          next_date = new Date()
          $scope.next_withdrawal_date = next_date.setMonth(next_date.getMonth()+1, 1)
        $scope.last_withdrawal_date = response.last_withdrawal_date
        $scope.total_accounts_balance = response.total_balance
        $scope.total_accounts_pending_deposits = response.total_pending_deposits
        $scope.total_accounts_available_balance = response.total_available_balance

    $scope.withdraw = (accts) ->
      @withdrawing = true;
      acct_ids = accts.map (acct) -> acct.id or acct
      $http.post "#{RENTAPPLICATION_API_URL}/api/v1/account/withdraw/?id__in=#{acct_ids}"
      .then () ->
        $scope.refresh_accounts()
      .catch (error) ->
        $scope.error = error.data
        if $scope.error.error_code == 'unverified'
          Flash.create('danger', 'Your account is not verified. Please verify your account under Settings > Bank Account.')
        else
          Flash.create('danger', "Something went wrong. Please contact #{$rootScope.SUPPORT_EMAIL}")
      .finally =>
        @withdrawing = false

    $scope.requestCsvReport = () ->
      $http.post "#{RENTAPPLICATION_API_URL}/api/v1/account/csv/"
      .then () ->
        Flash.create('success', "We are generating your csv, we email you when it's ready. You can navigate away from this page and we'll still notify you when it's complete")

    $scope.refresh_accounts = () ->
      $rootScope.$broadcast("accounts_changed")
      $cacheFactory.get("$http").removeAll()
      Account.query({ has_balance: true })
      .$promise.then (r) ->
        $scope.accounts = _.orderBy(r.results, ['balance'],['desc'])

    $scope.refresh_accounts()



// WEBPACK FOOTER //
// ./components/dashboard/payments/accounts/accounts.coffee